import { jsxs as m, jsx as t } from "react/jsx-runtime";
import { NotificationBarLoadingItem as e } from "../NotificationBarLoadingItem/index.js";
import { NotificationBarListContainer as l, NotificationBarListEmptyState as p } from "./style.js";
import { NotificationBarItem as u } from "../NotificationBarItem/index.js";
import { NotificationStatus as d } from "../../../types/schema.js";
import { useTranslation as f } from "../../../hooks/useTranslation/index.js";
function N() {
  const { t: i } = f("common");
  return /* @__PURE__ */ t(p, { children: i("notification-bar-list-empty-state") });
}
function B() {
  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    /* @__PURE__ */ m("div", { role: "progressbar", "aria-live": "polite", children: [
      /* @__PURE__ */ t(e, {}),
      /* @__PURE__ */ t(e, {}),
      /* @__PURE__ */ t(e, {}),
      /* @__PURE__ */ t(e, {}),
      /* @__PURE__ */ t(e, {}),
      /* @__PURE__ */ t(e, {})
    ] })
  );
}
function k({
  notifications: i,
  loading: a,
  getNotificationUrl: n,
  onNotificationClick: s
}) {
  const o = !!i.length;
  return /* @__PURE__ */ m(l, { "aria-busy": a, children: [
    o && i.map((r) => {
      const { deal: c } = r;
      return /* @__PURE__ */ t(
        u,
        {
          onClick: () => s(r.id),
          image: r.dealImage || "",
          text: r.text,
          date: r.createdAt,
          link: r.link,
          unread: r.status === d.NEW,
          deal: c,
          getNotificationUrl: n
        },
        r.id
      );
    }),
    a && /* @__PURE__ */ t(B, {}),
    !o && !a && /* @__PURE__ */ t(N, {})
  ] });
}
export {
  k as NotificationBarList
};
